import React, { ComponentProps } from 'react';
import { asView } from '../../../_lib/ViewFetcher';
import IForm from '../../../types/IForm';
import ConfigurationUpload from '../../../_lib/components/ConfigurationFileUpload/ConfigurationUpload';
import { Namespace } from '../../../translation/namespace';

type UserRegistrationPresetsEditProps = { form: IForm };

function UserRegistrationPresetsEdit({ form }: UserRegistrationPresetsEditProps) {
  return <ConfigurationUpload namespace={Namespace.UserRegistrationPresets} name="csvFile" form={form} />;
}

export const UserRegistrationPresetsEditView = asView(UserRegistrationPresetsEdit);
export type UserRegistrationPresetsEditView = ComponentProps<typeof UserRegistrationPresetsEditView>;
